<template>
  <section id="SectionSolar">
    <SectionSplit
      :headline="$t('headline')"
      src="../../assets/komanda.jpg">
      <h4>
        {{ $t('title') }}
      </h4>
      <p v-for="paragraph in $ta('paragraphs')" :key="paragraph">
        {{ paragraph }}
      </p>
    </SectionSplit>
    <!-- <Logos /> -->
    <!-- <Video2020 /> -->
  </section>
</template>

<script>
// import Logos from './Logos'
import SectionSplit from 'views/components/SectionSplit'
// import Video2020 from './Video2020'

export default {
  components: {
    SectionSplit,
    // Logos,
    // Video2020,
  },
}
</script>

<style lang="scss">
#SectionSolar {
  background-color: $grey-lightest;
}
</style>

<i18n>
{
  "lt": {
    "headline": "Nogrid",
    "title": "Saulės energijos lyderiai",
    "paragraphs": [
      "Mes esame inovatyvių ir kokybiškų saulės energijos sprendimų ekspertai. Veikdami nuo 2016 metų, jau turime daugiau nei 2000+ laimingų klientų Lietuvoje ir už jos ribų. Savo darbe laikomės aukščiausių profesionalumo standartų ir siūlome tik saugiausius bei efektyviausius technologinius sprendimus, užtikrinančius ilgalaikį projekto veikimą."
    ]
  }
}
</i18n>
